import { render, staticRenderFns } from "./WinnerGifts.vue?vue&type=template&id=230edf0a&"
import script from "./WinnerGifts.vue?vue&type=script&lang=js&"
export * from "./WinnerGifts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports